var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 180,
    viewBox: "0 0 286 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.662 35.5371V18.147L286.01 1V18.147L267.662 35.5371Z",
    fill: "#DE421E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.473 35.5371V18.147L267.662 1V18.147L251.473 35.5371Z",
    fill: "#F5C4B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1408 151.057C33.0261 151.057 36.8734 151.78 40.4631 153.184C44.0527 154.588 47.3143 156.647 50.0616 159.241C52.809 161.836 54.9883 164.917 56.4752 168.307C57.9621 171.697 58.7274 175.33 58.7274 179L29.1407 179L29.1408 151.057Z",
    fill: "#DE421E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5866 151.057C29.5866 154.726 28.8213 158.36 27.3345 161.75C25.8476 165.14 23.6683 168.221 20.9209 170.815C18.1735 173.41 14.9119 175.468 11.3223 176.873C7.73269 178.277 3.88537 179 -4.9126e-06 179L0 151.057L29.5866 151.057Z",
    fill: "#DE421E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6658 152.136C26.7805 152.136 22.9331 151.414 19.3435 150.009C15.7539 148.605 12.4923 146.547 9.74493 143.952C6.99756 141.357 4.81823 138.277 3.33136 134.887C1.8445 131.496 1.07922 127.863 1.07922 124.193L30.6658 124.193L30.6658 152.136Z",
    fill: "#DE421E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3385 152.136C30.3385 148.466 31.0613 144.833 32.4655 141.442C33.8698 138.052 35.9281 134.972 38.5228 132.377C41.1175 129.782 44.198 127.724 47.5881 126.32C50.9783 124.916 54.6119 124.193 58.2814 124.193L58.2814 152.136L30.3385 152.136Z",
    fill: "#DE421E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1407 115.404V100.731L44.2507 86.2637V100.731L29.1407 115.404Z",
    fill: "#F5C4B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2501 115.404V100.731L58.2808 86.2637V100.731L44.2501 115.404Z",
    fill: "#F5C4B9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    width: 180,
    height: 180,
    rx: 90,
    fill: "#DE421E",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2110_22126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 25,
    width: 130,
    height: 130
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 25,
    width: 130,
    height: 130,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2110_22126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.937 115.728H167.062V84.5817H158.937V115.728ZM163 75.3111C164.239 75.3111 165.279 74.8917 166.117 74.0531C166.956 73.2144 167.375 72.1753 167.375 70.9358C167.375 69.6963 166.956 68.6572 166.117 67.8185C165.279 66.9807 164.239 66.5618 163 66.5618C161.76 66.5618 160.721 66.9807 159.883 67.8185C159.044 68.6572 158.625 69.6963 158.625 70.9358C158.625 72.1753 159.044 73.2144 159.883 74.0531C160.721 74.8917 161.76 75.3111 163 75.3111ZM163.009 141.457C155.892 141.457 149.202 140.106 142.939 137.405C136.677 134.704 131.229 131.038 126.597 126.408C121.965 121.778 118.298 116.332 115.595 110.073C112.893 103.813 111.542 97.1244 111.542 90.0079C111.542 82.8904 112.892 76.2003 115.593 69.9377C118.294 63.6752 121.96 58.2278 126.59 53.5957C131.221 48.9635 136.666 45.296 142.926 42.5931C149.186 39.891 155.874 38.54 162.99 38.54C170.108 38.54 176.798 39.8906 183.061 42.5917C189.323 45.2928 194.771 48.9585 199.403 53.5889C204.035 58.2192 207.702 63.6643 210.405 69.9242C213.107 76.1841 214.458 82.8723 214.458 89.9889C214.458 97.1064 213.108 103.796 210.407 110.059C207.706 116.322 204.04 121.769 199.409 126.401C194.779 131.033 189.334 134.701 183.074 137.404C176.814 140.106 170.126 141.457 163.009 141.457ZM163 133.332C175.097 133.332 185.344 129.134 193.74 120.738C202.135 112.342 206.333 102.096 206.333 89.9984C206.333 77.9011 202.135 67.6546 193.74 59.2588C185.344 50.863 175.097 46.665 163 46.665C150.903 46.665 140.656 50.863 132.26 59.2588C123.865 67.6546 119.667 77.9011 119.667 89.9984C119.667 102.096 123.865 112.342 132.26 120.738C140.656 129.134 150.903 133.332 163 133.332Z",
    fill: "#DE421E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.46e99beb94cd1d1bffcbf2f2fc42adad.svg";
export { ForwardRef as ReactComponent };